import type { Group, ThemeClasses } from "../types";
import { GroupGridCard } from "./GroupGridCard";
import { GroupListRow } from "./GroupListRow";
import { DENSE_LIST } from "../../../../shared";

interface GroupListProps {
  groups: Group[];
  loading: boolean;
  selectedView: "grid" | "list";
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  onEdit: (group: Group) => void;
  onDelete: (group: Group) => void;
  onViewDetails: (group: Group) => void;
}

export function GroupList({
  groups,
  loading,
  selectedView,
  themeClasses,
  isDarkMode,
  onEdit,
  onDelete,
  onViewDetails,
}: GroupListProps) {
  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (groups.length === 0) {
    return (
      <div
        className={`text-center h-full text-lg flex flex-col items-center justify-center ${themeClasses.textSecondary}`}
      >
        <i className="ri-group-line text-6xl mb-4 opacity-30"></i>
        <p>No hay grupos</p>
      </div>
    );
  }

  if (selectedView === "grid") {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
        {groups.map((group) => (
          <GroupGridCard
            key={group.id}
            group={group}
            themeClasses={themeClasses}
            isDarkMode={isDarkMode}
            onEdit={onEdit}
            onDelete={onDelete}
            onViewDetails={onViewDetails}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={DENSE_LIST}>
      {groups.map((group) => (
        <GroupListRow
          key={group.id}
          group={group}
          themeClasses={themeClasses}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
}
